import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Orders from "./pages/Orders";
import AdminLogin from "./pages/AdminLogin";
import AdminSignup from "./pages/AdminSignup";
import AdminDashboard from "./pages/AdminDashboard";
import AddProduct from "./pages/AddProduct";
import SellerLogin from "./pages/SellerLogin";
import SellerSignup from "./pages/SellerSignup";
import SellerDashboard from "./pages/SellerDashboard";
import AddProductSeller from "./pages/AddProductSeller";
import SellerPrivateRoute from "./components/SellerPrivateRoute";
import EditProduct from "./pages/EditProduct";
import SellerProfile from "./pages/SellerProfile";
import About from "./pages/About";
import Contact from "./pages/Contact";




export default function App() {
return (
<AuthProvider>
<CartProvider>
<Router>
<div className="flex flex-col min-h-screen">
<Navbar />
<main className="flex-grow bg-transparent text-gray-900 dark:text-gray-100">
<Routes>
<Route path="/" element={<Home />} />
<Route path="/products" element={<Products />} />
<Route path="/about" element={<About />} />
<Route path="/contact" element={<Contact />} />
<Route path="/product/:id" element={<ProductDetail />} />
<Route path="/cart" element={<Cart />} />
<Route path="/checkout" element={<Checkout />} />
<Route path="/login" element={<Login />} />
<Route path="/signup" element={<Signup />} />
<Route path="/orders" element={<Orders />} />

{/* ADMIN PANEL ROUTES */}
  <Route path="/admin/login" element={<AdminLogin />} />
  <Route path="/admin/signup" element={<AdminSignup />} />
  <Route path="/admin/dashboard" element={<AdminDashboard />} />
  <Route path="/admin/add-product" element={<AddProduct />} />

  <Route path="/seller/login" element={<SellerLogin />} />
  <Route path="/seller/signup" element={<SellerSignup />} />
  <Route
    path="/seller/dashboard"
    element={
      <SellerPrivateRoute>
        <SellerDashboard />
      </SellerPrivateRoute>
    }
  />
  <Route
          path="/seller/add-product"
          element={
            <SellerPrivateRoute>
              <AddProductSeller />
            </SellerPrivateRoute>
          }
        />
  <Route path="/edit-product/:id" element={<EditProduct />} />
  <Route path="/seller/profile" element={<SellerProfile />} />

</Routes>


</main>
<Footer />
</div>
</Router>
</CartProvider>
</AuthProvider>
);
}